import { useCallback, useEffect, useState } from 'react';
import { AppConfig } from '../../Config/app-config';
import { axiosInstance } from '../../Helper/Api/axios.instance';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { useUserContext } from '../../context/user.context';

export const useTwitterMission = () => {
  const { profileData } = useUserContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const [twitterConnected, setTwitterConnected] = useState(false);

  useEffect(() => {
    setTwitterConnected(Boolean(profileData.twitterId));
  }, [profileData]);

  const twitterLogin = useCallback(async () => {
    const twitterAuthURL = new URL(
      `${AppConfig.apiUrl}${AppConfig.apiRoutes.twitterLogin()}`,
    );

    const a = document.createElement('a');
    a.href = twitterAuthURL.toString();
    a.target = '_blank';
    a.click();
    a.remove();
  }, []);

  useEffect(() => {
    const connectTwitterAccount = async (twitterAccessToken: string) => {
      try {
        const result = await axiosInstance.post(
          AppConfig.apiRoutes.connectTwitter(),
          {
            twitterAccessToken,
          },
        );

        if (result.data?.success) {
          toast.success(`Twitter account connected successfully!`);
          setTwitterConnected(true);
          return;
        }

        toast.error(result.data.message);
      } catch (error) {
        console.error(error);
      }
    };

    if (searchParams.has('twitterAccessToken')) {
      void connectTwitterAccount(searchParams.get('twitterAccessToken'));
      setSearchParams({});
    }
  }, [searchParams]);

  return {
    twitterLogin,
    twitterConnected,
  };
};
